import { render, staticRenderFns } from "./script-show.vue?vue&type=template&id=84d2ddfa&"
import script from "./script-show.vue?vue&type=script&lang=js&"
export * from "./script-show.vue?vue&type=script&lang=js&"
import style0 from "./script-show.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports